import React from 'react';

const Header = () => {
  return (
    <header>
      <div className="container">
        <h1>Core Values Guide</h1>
        <p>An interactive exercise to discover your personal values</p>
      </div>
    </header>
  );
};

export default Header;